module.exports = __webpack_public_path__ + "img/anquan.60776ecb.svg";